var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_32203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.91758L9.04258 9.33516C8.75 8.75 8.75 8.4957 8.75 8.16758C9.04258 7.875 9.625 7.58516 9.625 7.29258C9.91758 6.41758 9.91758 5.83516 9.91758 5.83516C10.068 5.61641 10.5 5.25273 10.5 4.66758C10.5 4.08242 9.91758 3.5 9.91758 3.21016C9.91758 0.875 8.72813 0 7 0C5.3457 0 4.08242 0.875 4.08242 3.20742C4.08242 3.5 3.5 4.08242 3.5 4.66484C3.5 5.24727 3.91563 5.63281 4.08242 5.83242C4.08242 5.83242 4.08242 6.41484 4.375 7.28984C4.375 7.58242 4.95742 7.87227 5.25 8.16484C5.25 8.45742 5.25 8.74727 4.95742 9.33242L1.75 9.91758C0.582422 10.2074 0 12.25 0 14H14C14 12.25 13.4176 10.2074 12.25 9.91758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_32203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertsIcon);
export default __webpack_public_path__ + "static/media/experts-icon.be402771b37823b1168e81f1abd35497.svg";
export { ForwardRef as ReactComponent };